import { render, staticRenderFns } from "./CreateEventModal.vue?vue&type=template&id=fec742f6"
import script from "./CreateEventModal.vue?vue&type=script&lang=ts"
export * from "./CreateEventModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports